import axios from 'axios';
import QueryString from 'query-string';
import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';
import { FilterValues, TableParams, UnreadMessages } from '@components/Overview/types';

export const fetchEvents = async (
  tableParams: TableParams,
  filterValues: FilterValues | undefined,
  unreadMessages: UnreadMessages[],
  signal: AbortSignal,
  includeChannelsOptedData = false
) => {
  const url = ApiUrl('/overview/bid_requests');

  return axios.post(
    url,
    {
      ...filterValues,
      ...(includeChannelsOptedData && { channels_opted_data: true }),
      page: tableParams.pagination?.current,
      page_size: tableParams.pagination?.pageSize,
      search: filterValues?.search?.trim(),
      sort_field: tableParams.sortField,
      sort_order: tableParams.sortOrder,
      unread_messages: unreadMessages
    },
    { signal }
  );
};

export const fetchPriceDeltas = async (eventIds: number[]) => {
  const url = ApiUrl('/overview/bid_requests/price_deltas');

  // using post instead of get because length of
  // event_ids could potentially be too long for path params
  return axios.post(url, {
    event_ids: eventIds
  });
};

export const fetchTotalCostChanges = (eventIds: string[], signal?: AbortSignal) => {
  const query = QueryString.stringify({ event_ids: eventIds }, { arrayFormat: 'bracket' });
  const url = ApiUrl(`/overview/bid_requests/total_cost_changes?${query}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { total_cost_changes: 'total_cost_changes' } },
    true,
    'json',
    signal ? { signal } : null
  );
};

export interface BulkUpdateParams {
  bid_request_ids: string[];
  hidden_from_dashboard?: boolean;
  tag_names?: string[];
}

export const bulkUpdateEvents = async (params: BulkUpdateParams) => {
  const url = ApiUrl('/bid_request_bulk_updates');

  return axios.post(url, params);
};

export const hideEvent = async (eventId: number, hiddenFromDashboard: boolean) => {
  const url = ApiUrl(`/bid_requests/${eventId}/hide`);

  return axios.put(url, { hidden_from_dashboard: hiddenFromDashboard });
};
